import { translate } from "app/filters/i18nFilter";
import { useMemo, useState } from "react";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import type { ICategory } from "app/common/services/categoryService.types";
import { validateMarketName } from "../services/MarketNameValidator";

/**
 * Custom industry name hook. exposes an on-update-industry-name method.
 * when this method is called - the hook automatically runs name formatting
 * and validation on the updated name, and returns an object that contains
 * details about the updated name.
 */
export const useMarketName = (category?: ICategory | { name?: string; categoryId?: string }) => {
    const services = useMemo(() => {
        return {
            customCategoriesService: UserCustomCategoryService,
        };
    }, []);
    const marketNameArg = category?.name ?? String();
    const categoryId = category?.categoryId;
    const [hasInitializedName, setHasInitializedName] = useState(false);
    const [marketName, setIndustryName] = useState(marketNameArg);
    const [hasErrorWithName, setHasErrorWithName] = useState(false);
    const [nameErrorMessage, setNameErrorMessage] = useState("");

    const userCategories = useMemo(() => {
        return services.customCategoriesService.getCustomCategories();
    }, [services]);

    const onUpdateMarketName = (updatedName) => {
        setHasInitializedName(true);

        const formattedName = updatedName.trim();
        setIndustryName(formattedName);

        const nameValidation = validateMarketName(formattedName, userCategories, translate, categoryId);
        setHasErrorWithName(!nameValidation.isValid);
        setNameErrorMessage(nameValidation.errorMsg);
    };

    return {
        marketName,
        onUpdateMarketName,
        hasErrorWithName,
        nameErrorMessage,
        hasInitializedName,
    };
};
